import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { StatusMessage } from '~/eds/src/components/StatusMessage/StatusMessage';
import { Text } from '~/eds/src/components/Text/Text';
import { api } from '~/redux/api/createApi';
import { selectTicketId } from '~/redux/selectors';

import { TicketCCRecipient } from './TicketCCRecipient';
import { TicketRecipient } from './TicketRecipient';

export const TicketRecipients = () => {
  const intl = useIntl();
  const ticketId = useSelector(selectTicketId);
  const { data, isLoading, error } = api.endpoints.getRecipients.useQuery({
    ticketId,
  });

  const signers = data?.signers ?? [];
  const cc = data?.carbonCopies ?? [];

  return (
    <>
      <Text color="text.quiet" variant="body-medium">
        {intl.formatMessage({
          id: 'TicketRecipients.recipientsHeader',
          defaultMessage: 'Recipients',
          description: 'Recipients section header',
        })}
      </Text>
      <ContentContainer loadingContent={{ isLoading }}>
        {error ? (
          <StatusMessage
            status="danger"
            message={
              error instanceof Error
                ? error.message
                : intl.formatMessage({
                    id: 'TicketRecipients.errorMessage',
                    defaultMessage:
                      'There was a problem with retrieving recipients. Please try again.',
                    description: 'Error message for recipients section',
                  })
            }
          />
        ) : (
          <>
            <Layout
              as="ul"
              direction="column"
              spacing={3}
              styles={{ padding: 0, margin: 0 }}
            >
              {signers?.map((recipient, index) => (
                <Layout
                  key={recipient.id}
                  styles={{ listStyle: 'none' }}
                  as="li"
                  borderBottom={
                    index < signers.length - 1 ? 'border' : undefined
                  }
                >
                  <TicketRecipient recipient={recipient} />
                </Layout>
              ))}
            </Layout>
            {cc.length > 0 && (
              <>
                <Text color="text.quiet" variant="body-medium">
                  {intl.formatMessage({
                    id: 'TicketRecipients.ccHeader',
                    defaultMessage: 'CC Recipients',
                    description:
                      'CC section header below signers on a ticket page',
                  })}
                </Text>
                <Layout
                  as="ul"
                  direction="column"
                  spacing={3}
                  styles={{ padding: 0, margin: 0 }}
                >
                  {cc.map((recipient, index) => (
                    <Layout
                      key={recipient.id}
                      styles={{ listStyle: 'none' }}
                      as="li"
                      borderBottom={
                        index < cc.length - 1 ? 'border' : undefined
                      }
                    >
                      <TicketCCRecipient recipient={recipient} />
                    </Layout>
                  ))}
                </Layout>
              </>
            )}
          </>
        )}
      </ContentContainer>
    </>
  );
};
